// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DQsP","colMin":"styles_colMin__KmJjJ"};